import React from "react";
import useAutomation from "./hooks/useAutomation";
import { PlayCircleFilledOutlined } from "@mui/icons-material";
import IconButton from "./IconButton";
import { Dropdown, Menu } from "antd";

const AutomationActions = () => {
    const { automationActions, isFetchingActions, handleExecuteAction } = useAutomation();

    const menu = () => {
        return (
            <div className="automation-menu">
                <Menu>
                    {automationActions.actions.map((action) => {
                        return (
                            <Menu.Item onClick={() => handleExecuteAction(action.actionId)}>{action.text}</Menu.Item>
                        );
                    })}
                </Menu>
            </div>
        );
    };

    return (
        <>
            {automationActions.actions?.length ? (
                <div className="automation">
                    <Dropdown overlay={menu} trigger={["click"]} placement="topRight">
                        <IconButton
                            icon={<PlayCircleFilledOutlined />}
                            type="primary"
                            className="flex"
                            style={{ gap: "10px" }}
                            loading={isFetchingActions}
                        >
                            Demo
                        </IconButton>
                    </Dropdown>
                </div>
            ) : null}
        </>
    );
};

export default AutomationActions;
